import { updateFloatDigits } from './updateFloatDigits';

export const convertPercentToValue = (total, percent) => {
  const currentAmount = (percent / 100) * total;
  return updateFloatDigits(currentAmount);
};

export const convertValueToPercent = (total, value) => {
  const currentAmount = (parseFloat(value) * 100) / total;
  return currentAmount.toFixed(0).toString();
};
